module.exports = __webpack_public_path__ + "media/assets/icons/review_user2-e9ac609abc227a41026c7242b68489df.svg";